import React from 'react';
import AccountForm from './AccountForm';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { KEY } from 'web/components/utils/stripeKey';
// import { CodeSharp } from '@material-ui/icons';

const BankACForm = ({ pageData, modalType, isOpen, toggle, callBackModal, onClickHander }) => {
  const stripePromise = loadStripe(KEY);
  return (<>
    <Elements stripe={stripePromise}>
      <AccountForm
        pageData={pageData}
        modalType={modalType}
        isOpen={isOpen}
        toggle={toggle}
        onClickHander={onClickHander}
        callBackModal={callBackModal} />
    </Elements>
  </>
  );
};

export default BankACForm;
